import { MapType } from '../MapType'
import { ProductValues } from '../ProductValues'

/**
 * Encapsulates parameters used to make requests to [MapService].
 */
export class FramesByProductsRequest {
  /**
   * Gets or sets the map type.
   */
  public mapType: MapType

  /**
   * Gets or sets a variable list of specific global map products.
   */
  public products: ProductValues[]

  /**
   * Gets or sets whether to include JSON query attribution information for the source data.
   */
  public includeAttribution = false

  /**
   * Gets or sets whether to ensure the response is not stale/cached.
   * Defaults to false, meaning a cached result will be returned if available.
   */
  public refreshCache = false

  /**
   * Initializes a new [FramesByProductsRequest].
   * @param mapType The map type.
   * @param products A variable list of specific global map products.
   */
  constructor(mapType: MapType, products: ProductValues[]) {
    this.mapType = mapType
    this.products = products
  }
}
